import { render, staticRenderFns } from "./CommunitySelect.vue?vue&type=template&id=1c560735&"
import script from "./CommunitySelect.vue?vue&type=script&lang=js&"
export * from "./CommunitySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports